<template>
    <console-content max-width="1280" class="overflow-visible">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">더블엔씨 상품 조회</v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
            </v-col>
        </v-row>

        <v-row class="mt-6" align="center">
            <v-col cols="auto" class="pr-2">
                <v-text-field v-model="searchValue" label="더블엔씨 상품코드" dense outlined hide-details />
            </v-col>
            <v-col cols="auto" class="px-0">
                <v-btn color="primary" @click="search()">
                    <span>검색</span>
                </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="white" class="green--text" @click="excel()">
                    <v-icon left class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>
                    <span>엑셀다운로드</span>
                </v-btn>
            </v-col>
        </v-row>

        <v-simple-table class="elevation-1 mt-2">
            <thead>
                <tr>
                    <th width="100">코드</th>
                    <th width="100">교환허용일수</th>
                    <th width="110">교환허용시작일</th>
                    <th width="110">교환허용종료일</th>
                    <!-- <th width="200">이미지URL</th> -->
                    <th width="400">MMS 이용안내</th>
                    <th width="400">상품 상세 설명</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product, index in products" :key="index">
                    <td>{{ product.productCode }}</td>
                    <td>{{ product.exchangeAllowedDates }}</td>
                    <td>{{ product.exchangeStartDate }}</td>
                    <td>{{ product.exchangeEndDate }}</td>
                    <!-- <td><div>{{ imageUrl(product.images) }}</div></td> -->
                    <td><div v-html="product.mmsNotice"></div></td>
                    <td><div v-html="product.explation"></div></td>
                </tr>
            </tbody>
        </v-simple-table>
    </console-content>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
    },
    data() {
        return {
            mdiMicrosoftExcel,

            searchValue: null,

            products: []
        };
    },
    mounted() {
    },
    methods: {
        async search(){
            if(!this.searchValue){
                alert("더블엔씨 상품코드를 입력해주세요");
                return;
            }

            this.products = [];
            this.searchValue.split(",").forEach((productCode) => {
                this.products.push({
                    productCode,
                });
            });

            let ymdhis = this.$dayjs().format("YYYYMMDDHHmmss");
            for(let index in this.products){
                if((+index+1) % 3 == 0) await this.sleep();
                let { product } = await api.console.platforms.barocon.get({
                    params: {
                        ...this.products[index],
                        campaignCode: "M2422088",
                        tradeId: `${ymdhis}${String(+index+1).padStart(3, '0')}`
                    }
                });

                this.$set(this.products, index, {
                    ...this.products[index],
                    ...product
                });
            }
        },
        sleep(){
            return new Promise((resolve) => {
                setTimeout(() => resolve(), 1000);
            });
        },
        imageUrl([image]){
            if(!image) return;

            return image.imageUrl.split("|").map(path => `https://proxy.bizpopcon.link/image` + path).join(',');
        },
        async excel() {
            if(!this.products.length){
                alert("조회를 먼저 해주세요");
                return;
            }

            var datas = [];
            this.products.forEach((product) => {
                datas.push({
                    "코드": product.productCode,
                    "교환허용일수": product.exchangeAllowedDates,
                    "교환허용시작일": product.exchangeStartDate,
                    "교환허용종료일": product.exchangeEndDate,
                    "이미지URL": this.imageUrl(product.images),
                    "MMS 이용안내": product.mmsNotice,
                    "상품 상세 설명": product.explation
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "더블엔씨 상품 조회");
            XLSX.writeFile(workbook, "더블엔씨 상품 조회.xlsx");
        },
    },
};
</script>